import { render } from "./SectionNine.vue?vue&type=template&id=37580f7d&scoped=true"
const script = {}

import "./SectionNine.vue?vue&type=style&index=0&id=37580f7d&lang=css&scoped=true"

import exportComponent from "/Users/konradfigura/Developer/first-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37580f7d"]])

export default __exports__